import type { SurfaceContextLike } from '../contracts/surface.context.contracts';
import type { CompiledSurfaceSchema } from '../runtime/compiled.form';
import { SURFACE_CAPABILITY_SLOT } from '../runtime/surfaces/surface.schema.slots';
import { visibleFieldDeclarations, type SectionFieldDeclaration } from '../sections/wb.section.component';
import type { SectionRenderInfo } from './surface.section.render.info';
import { visibleSectionsForPaths } from './surface.section.presenter';

/** Header controls for the reserved capability slot, in mount order; hidden or renderer-less fields drop out. */
export function surfaceCapabilityFields(compiled: CompiledSurfaceSchema, sections: ReadonlyMap<string, SectionRenderInfo>, page: SurfaceContextLike): readonly SectionFieldDeclaration[] {

  const paths = compiled.namedSlotSections[SURFACE_CAPABILITY_SLOT] ?? [];
  if (paths.length === 0) return [];
  return visibleSectionsForPaths(paths, sections, page)
    .flatMap(section => visibleFieldDeclarations(section.fields))
    .filter(field => !!field.customRenderer);
}
